type Props = {
  id?: string;
  message: string | null | undefined;
};

export function FormError({ id, message }: Props) {
  if (!message) return null;
  return (
    <p
      id={id}
      role="alert"
      aria-live="polite"
      className="bg-destructive/10 text-destructive rounded-lg px-3 py-2 text-sm"
    >
      {message}
    </p>
  );
}

export function FieldError({ id, message }: Props) {
  if (!message) return null;
  return (
    <p id={id} className="text-destructive text-xs" role="alert">
      {message}
    </p>
  );
}
